/* eslint-disable react/prop-types */
import React from 'react';
import headerModule from 'canopy-common-fo/src/modules/header';
import configurationService from 'canopy-common-fo/src/server/services/configService';

import { getServerSidePropsLoader, regroupModuleReducers, Context, GetServerSidePropsReturn } from '@next-common/redux-apollo-helper';
import { renderReact } from '../../fragmentHelper/renderReactCustom';

import { ReduxApolloFragmentWrapperChildren } from '../../fragmentHelper/Wrapper';

import { createQuery } from './PageQuery';
import { GetServerSidePropsHypernovaWatchContext, PagePropsType } from '../../types'

export { headerModule };

const config = configurationService.get();

const { HeaderContainer } = headerModule.containers;

const graphQlQuery = createQuery({
  headerModule,
}, {
  // includePersonalQuery: config.featureFlipping.ssrPersonalize,
  // includePersonalQuery: typeof window !== 'undefined',
  includePersonalQuery: config.featureFlipping.ssrPersonalize || typeof window !== 'undefined',
  // includePersonalQuery: true,
});

const reducers = regroupModuleReducers([headerModule]);

const graphQlvariables = {};

const WrappedHeader: React.FC<PagePropsType> = ({
  initialApolloState,
  initialReduxState,
  moduleName,
}) => (
  <ReduxApolloFragmentWrapperChildren
    initialApolloState={initialApolloState}
    initialReduxState={initialReduxState}
    moduleName={moduleName}
    reducers={reducers}
  >
    <HeaderContainer
      PERSONALIZED_QUERY_OPTION={graphQlvariables}
      PERSONALIZED_QUERY={graphQlQuery}
    />
  </ReduxApolloFragmentWrapperChildren>
);

export const renderFunction = renderReact('Header', WrappedHeader);


const modules = [headerModule];

export const serverCanCache = !config.featureFlipping.ssrPersonalize;

export const getServerSideProps = async (watchContext: GetServerSidePropsHypernovaWatchContext): Promise<GetServerSidePropsReturn> => {
  const baseUrl = null;
  const preloadedConfig = null;
  const graphQlVariables = {};

  const {
    initialReduxState,
    initialApolloState,
  } = await getServerSidePropsLoader(
    watchContext,
    modules,
    baseUrl,
    preloadedConfig,
    graphQlQuery,
    graphQlVariables,
  );
  return {
    props: {
      initialReduxState,
      initialApolloState,
    },
  };
};
